module.exports = __webpack_public_path__ + "img/76.3ea11ab4.svg";